export default __webpack_public_path__ + "static/media/img (1).bf34b22c.jpg";